/**
 * JSTの日付文字列(YYYY-MM-DD)をUTC ISO 8601形式に変換する
 * @param jstDateString JST日付文字列 (例: "2024-01-15")
 * @param isEndOfDay trueの場合は23:59:59.999 JST、falseの場合は00:00:00 JSTを基準にする
 * @returns UTC ISO 8601形式の文字列
 */
const convertJstDateToUtcIso = (jstDateString: string, isEndOfDay: boolean): string => {
  if (isEndOfDay) {
    // 23:59:59.999 JST → UTC
    const jstDate = new Date(`${jstDateString}T23:59:59.999+09:00`);
    return jstDate.toISOString();
  } else {
    // 00:00:00 JST → UTC
    const jstDate = new Date(`${jstDateString}T00:00:00+09:00`);
    return jstDate.toISOString();
  }
};

export default convertJstDateToUtcIso;
